// extracted by mini-css-extract-plugin
export default {"goToPaymentButton":"index-module__goToPaymentButton___P_lT9","small":"index-module__small___ObGjg"};